module.exports = __webpack_public_path__ + "static/step3-f68941576f3ee6be8be4effab4961e5b.png";